<script setup lang="ts">
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { computed, shallowRef } from 'vue'
import { useElementBounding, useWindowSize } from '@vueuse/core'
import FeatherIcon from 'vue-material-design-icons/Feather.vue'
import '@/features/story-conversation/components/conversationMenu.css'

withDefaults(defineProps<{ depth?: number }>(), { depth: 0 })
defineEmits<{ close: [] }>()
const button = shallowRef<HTMLButtonElement | null>(null)
const { bottom, right, update } = useElementBounding(button)
const { width, height } = useWindowSize()
const placement = computed(() => ({
  top: `${bottom.value + 10}px`,
  right: `${Math.max(12, width.value - right.value)}px`,
  maxHeight: `${Math.max(0, Math.min(height.value * 0.72, height.value - bottom.value - 22, 640))}px`,
}))
</script>

<template>
  <Popover
    v-slot="{ open, close }"
    class="conv-tools__menu-wrap"
  >
    <PopoverButton as="template">
      <button
        ref="button"
        class="conv-tools__menu-btn"
        aria-label="Menu"
        title="Conversation menu"
        @click="update"
      >
        <FeatherIcon :size="20" />
      </button>
    </PopoverButton>
    <Teleport to="body">
      <Transition
        name="conv-menu"
        @after-leave="$emit('close')"
      >
        <div
          v-if="open"
          class="conv-menu-layer"
        >
          <div
            class="conv-menu__scrim"
            aria-hidden="true"
            @click="close()"
          />
          <PopoverPanel
            static
            focus
            class="conv-menu manuscript-surface"
            :style="{ '--drill': depth, ...placement }"
          >
            <slot :close="close" />
          </PopoverPanel>
        </div>
      </Transition>
    </Teleport>
  </Popover>
</template>
